// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e59f83c","453":"878ecce8","455":"2f0787cc","884":"b7c37d9f"}[chunkId] + ".chunk.js";
};